import { AdUnitBuilderState, defaultAdUnitBuilderState } from "../state";
import { combineReducersPartial } from "../../reducer-factory";
import { assetFormReducer } from "./assetFormReducer";
import { getAdUnitsListRequest, getAdUnitByIdRequest } from "../../../common";
import { AdUnitFileUploadingStatusChangesAction } from "../actions";
import { adUnitBuildingReducer } from "./adUnitBuildingReducer";

export const adUnitBuilderReducer = combineReducersPartial<AdUnitBuilderState>(
    {
        assetForms: assetFormReducer,
        adUnitList: getAdUnitsListRequest.reducer,
        adUnitBuilding: adUnitBuildingReducer,
        adUnitById: getAdUnitByIdRequest.reducer,
        uploadingFileId: (state, action) => {
            if (AdUnitFileUploadingStatusChangesAction.is(action)) {
                return action.uploadingFileId;
            }

            return state;
        }
    },
    defaultAdUnitBuilderState
);
